// extracted by mini-css-extract-plugin
export default {"NotFound":"Errors_NotFound__gITaM","NotAuthorized":"Errors_NotAuthorized__qoaCe","Logo":"Errors_Logo__6XMtf","Title":"Errors_Title__-og2v","Layout":"Errors_Layout__2X1nA"};